<template>
<div>
    <div class="header">
        <h1 class="page_title">歡迎使用 iCare3+1</h1>
    </div>
    <div class="container">
        <div class="card-hold">
            <div class="c-card">
                <div class="circle-box">
                    <div class="circle"></div>
                    <div class="circle-1"></div>

                </div>
                <div class="c-content color" v-if="!error">
                    <div class="col-md-10 mx-auto w">
                        <h2>頁面載入中請稍後</h2>
                        <h3 style="margin-top:10px; color:#df43779d; font-weight: bold;">載入過程中會有轉跳，請不要關閉本頁面，謝謝。</h3>
                    </div>
                </div>
                {{lineID}}
                <div class="c-content color" v-if="error">
                    <div class="col-md-10 mx-auto w">
                        <h2>頁面載入錯誤！！！</h2>
                        <h3 style="margin-top:10px; color:#df43779d; font-weight: bold;">請重新開啟，或洽客服人員！！！</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footers></footers>
</div>
</template>
<script>
import { Footers } from '@f/layout'
import { mapGetters } from 'vuex'
export default {
    components: {
        Footers
    },
    data(){
        return {
            liffid: $('#liffid').text(), page: '', error: false,
            lineBasiclID: process.env.MIX_LINE_BASIC_ID ? process.env.MIX_LINE_BASIC_ID: '669ftuqw',
        }
    },
    created() {
        let queryString = decodeURIComponent(window.location.search).replace("?liff.state=", "");
        let params = new URLSearchParams(queryString);
        let state = params.get('state')? params.get('state') : null;
        this.page = params.get('page')? params.get('page') : '';

        if(state == null){
            // 不是在 line login 轉址中 才開始判斷，這時候才能取得 params
            if(this.page === ''){  
                console.log('page is null')
                this.swalError()
                this.error = true
                return
            }
        }

        this.init()
    },
    mounted() {
        
    },
    computed: {
        ...mapGetters([
            'lineID'
        ]),
    },
    methods:{
        async init(){
            this.swalProccess('載入中請稍候...')
            try{
                const res = await this.initLiff(this.liffid)
                if(res[0]){
                    // TODO redirect page
                    this.swalClose()
                    window.location = '/liff/test'
                }else{
                    console.log('res err'+res[1])
                }
            }catch(err){
                console.log('init err'+err)
            }
        },
    }
}
</script>